module.exports = __webpack_public_path__ + "img/vrch-s-kapuci_81_reflexni-zluta.2b51f6f2.png";